var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EBC7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 28C18.5523 28 19 27.5523 19 27C19 26.4477 18.5523 26 18 26V27V28ZM15.75 27V28H18V27V26H15.75V27ZM14 28.75H13V29H14H15V28.75H14ZM14 29H13C13 30.3807 14.1193 31.5 15.5 31.5V30.5V29.5C15.2239 29.5 15 29.2761 15 29H14ZM15.75 27V26C14.2312 26 13 27.2312 13 28.75H14H15C15 28.3358 15.3358 28 15.75 28V27Z",
    fill: "#523F83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17V18V19ZM15.75 18V19H18V18V17H15.75V18ZM14 19.75H13V20H14H15V19.75H14ZM14 20H13C13 21.3807 14.1193 22.5 15.5 22.5V21.5V20.5C15.2239 20.5 15 20.2761 15 20H14ZM15.75 18V17C14.2312 17 13 18.2312 13 19.75H14H15C15 19.3358 15.3358 19 15.75 19V18Z",
    fill: "#523F83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 14C31.3284 14 32 14.6716 32 15.5V33.5C32 34.3284 31.3284 35 30.5 35H18.5C17.6716 35 17 34.3284 17 33.5V29.5H20V28H17V20.5H20V19H17V15.5C17 14.6716 17.6716 14 18.5 14H30.5Z",
    fill: "#523F83"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.bb0760182bf58e84f59f5a04e6143802.svg";
export { ForwardRef as ReactComponent };